import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import Highlightable from "highlightable";
import WideContainer from "../../components/WideContainer";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import VolumeMuteIcon from "@mui/icons-material/VolumeMute";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Popover from "@mui/material/Popover";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import SaveIcon from "@mui/icons-material/Save";
import DeleteIcon from "@mui/icons-material/Delete";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckIcon from "@mui/icons-material/Check";
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import TextField from "@mui/material/TextField";
import DialogTitle from "@mui/material/DialogTitle";
import Snackbar from "@mui/material/Snackbar";
import Alert from '@mui/material/Alert';
import Checkbox from "@mui/material/Checkbox";
import Tooltip from "@mui/material/Tooltip";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import CircularProgress from "@mui/material/CircularProgress";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import {
  Player,
  ControlBar,
  BigPlayButton,
  LoadingSpinner,
  PlayToggle,
  VolumeMenuButton,
  FullscreenToggle,
  CurrentTimeDisplay,
  TimeDivider,
  DurationDisplay,
  ProgressControl,
} from "video-react";
import { fetchSentences } from "../../slices/sentences";
import { Trans, withTranslation } from "react-i18next";

import "../../../node_modules/video-react/dist/video-react.css";
import axios from "../../components/Axios";
import "./Queries.css";

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loading_items: false,
      items: [this.props.video],
      source: 0,
      sourceDialogAnchor: null,
      tab: "characters",
      segments: [],
      selected: new Set([]),
      sentences: [],

      redact_chars: [],
      muteOpen: false,
      muteValue: "",
      muteAnchorEl: undefined,

      textDialogAnchor: null,
      redact_text_type: "MUTE", //BEEP, MUTE
      redact_text_all: false,
      redact_text_data: false,
      text_redaction_states: [],

      redact_objs: [],
      redact_logos: new Set([]),
      targetObj: false,

      player: {
        duration: 0,
      },
      playerSource: undefined,
      extractDialog: false,
      extractSuccessDialog: false,
      extractName: "",
    };

    this.sentenceRef = [];
    this.tvideo = React.createRef();
    this.objBox = React.createRef();
    this.handleChange = this.handleChange.bind(this);
    this.handleTabChange = this.handleTabChange.bind(this);
    this.handleMuteChange = this.handleMuteChange.bind(this);
    this.handleTextTypeChange = this.handleTextTypeChange.bind(this);
    this.seekThumbnails = this.seekThumbnails.bind(this);
    this.getThumbnail = this.getThumbnail.bind(this);
    this.loadRedactions = this.loadRedactions.bind(this);
    this.loadCharacters = this.loadCharacters.bind(this);
    this.setSource = this.setSource.bind(this);
    this.setCustomObjects = this.setCustomObjects.bind(this);
    this.seek_time = 0;
  }

  componentDidMount() {
    // subscribe state change
    this.player.subscribeToStateChange(this.handleStateChange.bind(this));

    this.setState({
      loading: true,
    });

    this.loadCharacters();
    if (this.props.videosrc !== undefined) {
      this.setState({ playerSource: this.props.videosrc });
    }
  }

  loadCharacters() {
    axios
      .get("/video_project/" + this.props.project.project_id + "/characters")
      .then(
        function (response) {
          let rc = [];
          for (var i in response.data) {
            //set audio & video
            if (response.data[i].char_id >= 0) {
              rc.push({
                char_id: response.data[i].char_id,
                char_name: response.data[i].char_name,
                rep_track_id: response.data[i].rep_track_id,
                occurences: response.data[i].tracks_data.length,
                audio_redaction: "AUDIBLE",
                video_redaction: false,
              });
            }
          }

          this.setState({
            redact_chars: rc,
          });
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log(error);
          //this.setState({ loading: false });
        }.bind(this)
      );
  }

  loadRedactions(v) {
    axios
      .get("/redaction/redaction_state/" + v.video_id)
      .then(
        function (response) {
          //set text_redaction_states
          this.setState({
            text_redaction_states: response.data.text_redaction_states_list,
          });

          //set character dic
          let rc = {};
          for (let r of response.data.character_redaction_states_list) {
            rc[r.char_id] = r.audio_redaction;
          }

          //set sentences dic
          let rs = {};
          for (let r of response.data.text_redaction_states_list) {
            for (let s of r.text_time_segments_list) {
              let range = {
                text: r.text,
                all_occurrences: r.all_occurrences,
                audio_redaction: r.audio_redaction,
                text_time_segment: {
                  sentence_id: s.sentence_id,
                  start_idx: s.start_idx,
                  end_idx: s.end_idx,
                },
                start: s.start_idx,
                end: s.end_idx,
              };

              if (s.sentence_id in rs) {
                rs[s.sentence_id].push(range);
              } else {
                rs[s.sentence_id] = [range];
              }
            }
          }

          //set obj array
          this.setCustomObjects(response.data.object_redaction_states_list);

          for (let k in this.props.sentences.items) {
            if (this.props.sentences.items[k].sentence_id in rs) {
              this.props.dispatch({
                type: "sentences/setRange",
                payload: {
                  item_index: k,
                  ranges: rs[this.props.sentences.items[k].sentence_id],
                },
              });
              //this.props.sentences.items[k].ranges =
              //  rs[this.props.sentences.items[k].sentence_id];
            }
          }

          this.setState(function (state) {
            for (let k in state.redact_chars) {
              if (state.redact_chars[k].char_id in rc) {
                state.redact_chars[k].audio_redaction =
                  rc[state.redact_chars[k].char_id];
                state.redact_chars[k].video_redaction = true;
              } else {
                state.redact_chars[k].video_redaction = false;
              }
            }

            return state;
          });
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log(error);
          //this.setState({ loading: false });
        }.bind(this)
      );
  }

  setCustomObjects(l) {
    let list = l;

    if (this.player.video.video.videoWidth === 0) {
      //wait for video dimensions
      setTimeout(
        function () {
          this.setCustomObjects(list);
        }.bind(this),
        200
      );
    } else {
      let oa = [];
      let ratio = [
        this.player.video.video.videoWidth /
        this.player.video.video.offsetWidth,
        this.player.video.video.videoHeight /
        this.player.video.video.offsetHeight,
      ];
      for (let r of list) {
        oa.push({
          frame_time: r.object.frame_time,
          x: r.object.coordinates[0].x / ratio[0],
          y: r.object.coordinates[0].y / ratio[1],
          w: (r.object.coordinates[1].x - r.object.coordinates[0].x) / ratio[0],
          h: (r.object.coordinates[2].y - r.object.coordinates[1].y) / ratio[1],
        });
      }
      this.setState({ redact_objs: oa });

      //show control after changing video
      if (this.state.tab === "track" && !this.state.player.hasStarted) {
        this.player.play();
        this.player.pause();
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.playerSource !== prevState.playerSource) {
      this.player.load();
    }
    if (this.props.videosrc !== prevProps.videosrc) {
      this.setState({
        playerSource: this.props.videosrc,
        items: [this.props.video],
      });
    }
  }

  setSentenceRef = (ref) => {
    this.sentenceRef.push(ref);
  };

  handleStateChange(state) {
    // copy player state to this component's state
    this.setState({
      player: state,
    });

    //do not scroll when paused
    if (state.paused) return;

    for (var i in this.props.sentences.items) {
      if (
        this.props.sentences.items[i].start_time - 0.5 < state.currentTime &&
        state.currentTime < this.props.sentences.items[i].end_time
      ) {
        this.sentenceRef[i].scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        });
        break;
      }
    }
  }

  handleTabChange(v, e) {
    this.setState({ tab: v.target.value });
    if (v.target.value === "track" && !this.state.player.hasStarted) {
      this.player.play();
      this.player.pause();
    }
  }

  handleChange(v, e) {
    this.setState({ [v.target.name]: v.target.value });
  }

  toggleChar(k) {
    let t = this.state.redact_chars[k].video_redaction;
    this.setState(function (state) {
      state.redact_chars[k].video_redaction = !t;
      return state;
    });
  }
  toggleLogo(id, remove) {
    this.setState(function (state) {
      if (remove) state.redact_logos.delete(id);
      else state.redact_logos.add(id);
      return state;
    });
  }
  toggleMute(k, e) {
    this.setState({
      muteOpen: k,
      muteAnchorEl: e.currentTarget,
      muteValue: this.state.redact_chars[k].audio_redaction,
    });
  }
  handleMuteChange(v) {
    let val = v.target.value;
    this.setState(function (state) {
      state.muteValue = val;
      state.redact_chars[state.muteOpen].audio_redaction = val;
      state.redact_chars[state.muteOpen].video_redaction = true;
      return state;
    });
  }
  muteClose() {
    this.setState({
      muteOpen: false,
      muteAnchorEl: undefined,
    });
  }

  openSourceMenu(e) {
    this.setState({ sourceDialogAnchor: e.target, loading_items: true });
    axios
      .get(
        "/video_project/" +
        this.props.project.project_id +
        "/videos?video_type=REDACTION"
      )
      .then(
        function (response) {
          response.data.unshift(this.props.video);
          this.setState({
            loading_items: false,
            items: response.data.filter((i) => i.status === "PROCESSED"),
          });
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log(error);
          this.setState({ loading: false });
        }.bind(this)
      );
  }
  closeSourceMenu() {
    this.setState({ sourceDialogAnchor: null });
  }
  setSource(i) {
    this.setState({
      sourceDialogAnchor: null,
      source: i,
      playerSource: this.state.items[i].video_path,
    });

    if (i !== this.state.source) {
      //clear states
      this.setState(function (state) {
        //chars
        for (let k in state.redact_chars) {
          state.redact_chars[k].video_redaction = false;
        }
        //sentences
        this.props.dispatch({ type: "sentences/clearRange" });
        //for (let k in this.props.sentences.items) {
        //this.props.sentences.items[k].ranges = [];
        //}

        //objs
        state.redact_objs = [];

        return state;
      });

      //load redactions
      if (i !== 0) {
        this.loadRedactions(this.state.items[i]);
      }
    }
  }

  onHighlight(s, r) {
    this.setState({
      textDialogAnchor: this.sentenceRef[s.index],
      redact_text_data: {
        sentence: s,
        range: r,
      },
    });
  }

  textDialogClose() {
    this.setState({ textDialogAnchor: null });
  }
  handleTextTypeChange(v) {
    let val = v.target.value;
    this.setState({ redact_text_type: val });
  }
  handleTextAllChange(v) {
    this.setState({ redact_text_all: v.target.checked });
  }
  redactText() {
    let t = this.state.redact_text_data.range.text.trim();
    let end = this.state.redact_text_data.range.end;
    //adjust end if it is a space
    if (this.state.redact_text_data.range.text[end] == ' ') {
      end--;
    }
    let r = {
      text: t,
      audio_redaction: this.state.redact_text_type,
      all_occurrences: this.state.redact_text_all,
      text_time_segment: {
        sentence_id: this.state.redact_text_data.sentence.sentence_id,
        start_idx: this.state.redact_text_data.range.start,
        end_idx: end,
      },
      start: this.state.redact_text_data.range.start,
      end: end,
      //data: this.state.redact_text_data.range.data,
    };
    window.getSelection().removeAllRanges();

    this.props.dispatch({
      type: "sentences/addRange",
      payload: { id: this.state.redact_text_data.sentence.index, range: r },
    });

    //add state
    let s = [...this.state.text_redaction_states];
    s.push({
      all_occurrences: this.state.redact_text_all,
      audio_redaction: this.state.redact_text_type,
      text: t,
      text_time_segments_list: [
        {
          sentence_id: this.state.redact_text_data.sentence.sentence_id,
          start_idx: this.state.redact_text_data.range.start,
          end_idx: end,
          start_time:
            this.props.sentences.items[
              this.state.redact_text_data.sentence.index
            ].start_time,
        },
      ],
    });
    this.setState(function (state) {
      state.text_redaction_states = s;
      state.textDialogAnchor = null;
      return state;
    });
  }
  removeRedactText(k, l) {
    if (l !== null) {
      //remove single
      let segs = [
        ...this.state.text_redaction_states[k].text_time_segments_list,
      ];
      let rem = segs.splice(l, 1)[0];
      this.setState(function (state) {
        state.text_redaction_states[k].all_occurrences = false;
        state.text_redaction_states[k].text_time_segments_list = segs;
        return state;
      });

      if (segs.length === 0) {
        //remove whole if no more child
        let r = [...this.state.text_redaction_states];
        r.splice(k, 1);
        this.setState(function (state) {
          state.text_redaction_states = r;
          return state;
        });
      }

      //remove range
      for (let i in this.props.sentences.items) {
        if (this.props.sentences.items[i].sentence_id === rem.sentence_id) {
          for (var j in this.props.sentences.items[i].ranges) {
            if (
              this.props.sentences.items[i].ranges[j].start === rem.start_idx &&
              this.props.sentences.items[i].ranges[j].text ===
              this.state.text_redaction_states[k].text &&
              this.props.sentences.items[i].ranges[j].audio_redaction ===
              this.state.text_redaction_states[k].audio_redaction
            ) {
              this.props.dispatch({
                type: "sentences/removeRange",
                payload: { item_index: i, range_index: j },
              });
            }
          }
        }
      }
    }
  }
  removeRange(range) {
    for (let i in this.props.sentences.items) {
      if (
        this.props.sentences.items[i].sentence_id ===
        range.text_time_segment.sentence_id
      ) {
        for (var j in this.props.sentences.items[i].ranges) {
          if (
            this.props.sentences.items[i].ranges[j].start === range.start &&
            this.props.sentences.items[i].ranges[j].end === range.end &&
            this.props.sentences.items[i].ranges[j].audio_redaction ===
            range.audio_redaction
          ) {
            this.props.dispatch({
              type: "sentences/removeRange",
              payload: { item_index: i, range_index: j },
            });
            //this.props.sentences.items[i].ranges.splice(j, 1);
          }
        }
      }
    }

    //remove state
    for (let i in this.state.text_redaction_states) {
      if (this.state.text_redaction_states[i].text === range.text) {
        for (let j in this.state.text_redaction_states[i]
          .text_time_segments_list) {
          if (
            this.state.text_redaction_states[i].text_time_segments_list[j]
              .sentence_id === range.text_time_segment.sentence_id &&
            this.state.text_redaction_states[i].text_time_segments_list[j]
              .start_idx === range.start
          ) {
            let r = [
              ...this.state.text_redaction_states[i].text_time_segments_list,
            ];
            r.splice(j, 1);
            this.setState(function (state) {
              state.text_redaction_states[i].text_time_segments_list = r;
              return state;
            });

            if (r.length === 0) {
              //remove whole if no more child
              let r = [...this.state.text_redaction_states];
              r.splice(i, 1);
              this.setState(function (state) {
                state.text_redaction_states = r;
                return state;
              });
            }
          }
        }
      }
    }
  }
  tooltipRenderer(n, range, ri) {
    let c = {
      tooltip: "whiteTooltip",
    };
    return (
      <Tooltip
        key={`rtt-${ri}`}
        placement="top"
        arrow
        classes={c}
        interactive
        title={
          <IconButton
            aria-label="delete"
            size="small"
            onClick={this.removeRange.bind(this, range)}
          >
            <DeleteIcon fontSize="inherit" style={{ color: "#3f51b5" }} />
          </IconButton>
        }
      >
        <span className="redactTextHighlight">{n}</span>
      </Tooltip>
    );
  }
  customRenderer(crNodes, crRange, crIndex, onMouse) {
    return this.tooltipRenderer(crNodes, crRange, crIndex, onMouse);
  }

  formatDuration(s) {
    if (Number.isNaN(s)) return "0:00";

    let pad = function (num, size) {
      return ("000" + num).slice(size * -1);
    },
      time = parseFloat(s).toFixed(3),
      hours = Math.floor(time / 60 / 60),
      minutes = Math.floor(time / 60) % 60,
      seconds = Math.floor(time - minutes * 60);
    if (hours > 0) return hours + ":" + pad(minutes, 2) + ":" + pad(seconds, 2);
    else return minutes + ":" + pad(seconds, 2);
  }
  formatAudio(string) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  }

  seekVideo(t, p) {
    if (p === true) {
      this.player.pause();
    }
    this.player.seek(t);
  }

  seekThumbnails(e) {
    let q = this.state.segments.filter((i) => {
      return !("src" in i);
    });

    if (q.length > 0) {
      this.seek_time = q[0]["start_time"];
      this.tvideo.current.currentTime = this.seek_time;
    }
  }

  getThumbnail(e) {
    let canvas = document.createElement("canvas");
    canvas.width = this.tvideo.current.videoWidth;
    canvas.height = this.tvideo.current.videoHeight;
    let context = canvas.getContext("2d");
    context.drawImage(this.tvideo.current, 0, 0, canvas.width, canvas.height);
    let dataURI = canvas.toDataURL("image/jpeg");
    let t = this.seek_time;

    this.setState(function (state) {
      for (let i in state.segments) {
        if (state.segments[i].start_time === t) {
          state.segments[i].src = dataURI;
          break;
        }
      }

      setTimeout(() => {
        this.seekThumbnails(null);
      }, 1);

      return state;
    });
  }

  getThumbnailStyle(s) {
    if ("src" in s) return { backgroundImage: "url(" + s.src + ")" };
    return {};
  }

  getTimelineStyle(s, d) {
    let w = ((s.end_time - s.start_time) / d) * 100;
    let l = (s.start_time / d) * 100;

    return { left: l + "%", width: w + "%" };
  }

  getVideoRatio(w, h) {
    let p = (h / w) * 100;
    return p + "%";
  }

  isHighlight(s, r) {
    for (var i in r) {
      if (
        (r[i].start_time < s.start_time && s.start_time < r[i].end_time) ||
        (r[i].start_time < s.end_time && s.end_time < r[i].end_time)
      ) {
        return "true";
      }
    }
    return "false";
  }

  extractDialog(i, e) {
    this.setState({ extractDialog: true });
    if (this.state.extractName === "")
      this.setState({
        extractName: "Redaction",
      });
  }

  closeExtractDialog() {
    this.setState({ extractDialog: false });
  }

  extractJob() {
    let d = {
      project_id: this.props.project.project_id,
      source_video_id: this.state.items[this.state.source].video_id,
      video_name: this.state.extractName,
      character_redactions_list: [],
      object_redactions_list: [],
      text_redactions_list: [],
      logo_redactions_list: [],
    };

    //create character_redactions_list
    for (let i of this.state.redact_chars) {
      if (i.video_redaction === true) {
        d.character_redactions_list.push({
          char_id: i.char_id,
          audio_redaction: i.audio_redaction,
        });
      }
    }

    //create text_redactions_list
    d.text_redactions_list = this.state.text_redaction_states;

    d.logo_redactions_list = [...this.state.redact_logos];

    //create object_redactions_list
    for (let i of this.state.redact_objs) {
      let ob = this.objBox.current.getBoundingClientRect();
      let ratio = [
        this.player.videoWidth / ob.width,
        this.player.videoHeight / ob.height,
      ];
      let c = [
        i.x * ratio[0],
        i.y * ratio[1],
        (i.x + i.w) * ratio[0],
        (i.y + i.h) * ratio[1],
      ];

      d.object_redactions_list.push({
        frame_time: i.frame_time,
        coordinates: [
          { x: c[0], y: c[1] },
          { x: c[2], y: c[1] },
          { x: c[2], y: c[3] },
          { x: c[0], y: c[3] },
        ],
      });
    }

    this.setState({ extractSuccessDialog: true, extractDialog: false });
    axios
      .post("/dispatch_jobs/redaction", d)
      .then(
        function (response) {
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log(error);
          //this.setState({ loading: false });
        }.bind(this)
      );
  }

  closeExtractSuccessDialog() {
    this.setState({ extractSuccessDialog: false });
  }

  getThumbUrl(i) {
    if (i === -1) return "/img/people.png";
    return (
      JSON.parse(localStorage.getItem("user")).user_folder +
      "/" +
      this.props.project.project_folder +
      i
    );
  }

  mouseDown(e) {
    let ob = this.objBox.current.getBoundingClientRect();
    let x = e.clientX - ob.left;
    let y = e.clientY - ob.top;

    this.setState(function (state) {
      state.targetObj = state.redact_objs.length;
      state.redact_objs.push({
        frame_time: state.player.currentTime,
        x: x,
        y: y,
        w: 0,
        h: 0,
      });
      return state;
    });
  }
  mouseMove(e) {
    if (this.state.targetObj === false) return;

    let ob = this.objBox.current.getBoundingClientRect();
    let x = e.clientX - ob.left;
    let y = e.clientY - ob.top;

    this.setState(function (state) {
      state.redact_objs[state.targetObj].w =
        x - state.redact_objs[state.targetObj].x;
      state.redact_objs[state.targetObj].h =
        y - state.redact_objs[state.targetObj].y;
      return state;
    });
  }
  mouseUp(e) {
    this.setState(function (state) {
      //remove obj too small
      if (state.targetObj in state.redact_objs) {
        if (
          state.redact_objs[state.targetObj].w < 2 ||
          state.redact_objs[state.targetObj].h < 2
        ) {
          state.redact_objs.splice(state.targetObj, 1);
        }
      }
      state.targetObj = false;
      return state;
    });
  }
  removeRedactObj(k, e) {
    e.stopPropagation();
    let i = k;
    this.setState(function (state) {
      state.redact_objs.splice(i, 1);
      return state;
    });
  }

  preventMouseDown(e) {
    e.stopPropagation();
  }

  render() {
    return (<>
      <div className="topBar" style={{ zIndex: "0" }}>
        <WideContainer className="flex">
          <div
            className="mainColumn flex"
            style={{ borderRight: "1px solid #dfe7f0", height: "64px" }}
          >
            <div className="subjectText flex">
              {this.state.items[this.state.source].video_name + " "}
              <IconButton
                onClick={this.openSourceMenu.bind(this)}
                size="small"
              >
                <ExpandMoreIcon style={{ fontSize: "16px" }} />
              </IconButton>
              <Menu
                anchorEl={this.state.sourceDialogAnchor}
                keepMounted
                open={Boolean(this.state.sourceDialogAnchor)}
                onClose={this.closeSourceMenu.bind(this)}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
              >
                {this.state.items.map((i, k) => (
                  <MenuItem
                    onClick={this.setSource.bind(this, k)}
                    key={"smi" + k}
                    selected={k === this.state.source}
                  >
                    {i.video_name}
                    {k === this.state.source && <CheckIcon className="vv-menuCheck" />}
                  </MenuItem>
                ))}
                {this.state.loading_items && (
                  <div style={{ textAlign: "center" }}>
                    <CircularProgress size={20} />
                  </div>
                )}
              </Menu>
            </div>
            <div className="saveContainer flex">
              <Button disabled
                className="Button"
                size="small"
                onClick={this.extractDialog.bind(this, null)}
                endIcon={<SaveIcon style={{ color: "#1355B2" }} />}
              >
                <Trans>SAVE</Trans>
              </Button>
            </div>
          </div>
          <div className="sideColumn flex" style={{ maxWidth: "420px" }}>
            <ToggleButtonGroup
              style={{ margin: "0 auto" }}
              size="small"
              value={this.state.tab}
              exclusive
              onChange={this.handleTabChange}
            >
              <ToggleButton value="characters" className="minW120">
                <Trans>Character</Trans>
              </ToggleButton>
              <ToggleButton value="track" className="minW120">
                <Trans>Object</Trans>
              </ToggleButton>
              <ToggleButton value="digest" className="minW120">
                <Trans>Text</Trans>
              </ToggleButton>
            </ToggleButtonGroup>
          </div>
        </WideContainer>
      </div>
      <WideContainer
        className="flex"
        style={{ alignItems: "start" }}
      >
        <div
          className="mainColumn topBar bodyContent"
          style={{ height: "calc(100vh - 156px)" }}
        >
          <Player
            ref={(player) => {
              this.player = player;
            }}
            autoPlay={false}
            src={this.state.playerSource}
          >
            <BigPlayButton position="center" />
            <LoadingSpinner />
            <ControlBar autoHide={false} disableDefaultControls>
              <PlayToggle key="play-toggle" order={1} />
              <VolumeMenuButton key="volume-menu-button" order={4} vertical />
              <CurrentTimeDisplay key="current-time-display" order={5.1} />
              <DurationDisplay key="duration-display" order={7.3} />
              <ProgressControl key="progress-control" order={6} />
              <FullscreenToggle key="fullscreen-toggle" order={8} />
            </ControlBar>
            <div
              ref={this.objBox}
              className={
                this.state.tab !== "track" || !this.state.player.paused
                  ? "objectBox hide"
                  : "objectBox"
              }
              onMouseDown={this.mouseDown.bind(this)}
              onMouseMove={this.mouseMove.bind(this)}
              onMouseUp={this.mouseUp.bind(this)}
            >
              <div
                className="objectInstructionBox"
                hidden={
                  this.state.redact_objs.filter(
                    (i) => i.frame_time === this.state.player.currentTime
                  ).length > 0
                }
              >
                <Trans>Drag over object to redact</Trans>
              </div>
              {this.state.redact_objs.map((i, k) => (
                <Tooltip
                  key={"rdo" + k}
                  placement="top"
                  arrow
                  classes={{
                    tooltip: "whiteTooltip",
                  }}
                  interactive
                  title={
                    <IconButton
                      aria-label="delete"
                      size="small"
                      onClick={this.removeRedactObj.bind(this, k)}
                    >
                      <DeleteIcon
                        fontSize="inherit"
                        style={{ color: "#3f51b5" }}
                      />
                    </IconButton>
                  }
                  slotProps={{
                    popper: { onMouseDown: this.preventMouseDown }
                  }}
                >
                  <div
                    className="objectItem"
                    hidden={i.frame_time !== this.state.player.currentTime}
                    style={{
                      top: i.y + "px",
                      left: i.x + "px",
                      width: i.w + "px",
                      height: i.h + "px",
                    }}
                    onMouseDown={this.preventMouseDown}
                  >
                    <div className="objectNum">{k + 1}</div>
                  </div>
                </Tooltip>
              ))}
            </div>
          </Player>
          <div className="timelineHighlights"></div>
          <div className="transcriptBox">
            {this.props.sentences.loading === "pending" && (
              <CircularProgress
                style={{ margin: "40px auto", display: "block" }}
              />
            )}
            {this.props.sentences.items.map((s, i) => (
              <div
                className="transcriptSegment"
                key={"sentence" + s.sentence_id}
                data-highlight={this.isHighlight(s, this.state.segments)}
                onClick={this.seekVideo.bind(this, s.start_time)}
                ref={this.setSentenceRef}
              >
                <div className="subjectText transcriptTime">
                  {this.formatDuration(s.start_time)}
                </div>
                <div className="subjectText transcriptSubject">
                  {this.props.characters.dic[s.char_id]}
                </div>
                <div className="subjectSpeech transcriptSpeech">
                  <Highlightable
                    id={"sh" + i}
                    ranges={[...s.ranges]}
                    enabled={true}
                    onTextHighlighted={this.onHighlight.bind(this, s)}
                    rangeRenderer={this.customRenderer.bind(this)}
                    text={s.text}
                  />
                </div>
              </div>
            ))}
            {false && (
              <div className="transcriptSegment transcriptHighlighted">
                <div className="subjectText transcriptSubject">
                  Video State
                </div>
                <div className="subjectSpeech transcriptSpeech">
                  <div style={{ whiteSpace: "pre-wrap" }}>
                    {JSON.stringify(this.state.player, null, 2)}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div
          className="sideColumn extractArea bodyContent"
          style={{
            height: "calc(100vh - 156px)",
            maxWidth: "420px",
            padding: "0 16px",
            overflow: "auto",
          }}
        >
          {this.state.tab === "characters" &&
            this.state.redact_chars.map((i, k) => (
              <div
                className={
                  "flex redactRow" +
                  (i.video_redaction ? " redactRowActive" : "")
                }
                key={"rc" + k}
              >
                <div
                  className="characterListImg"
                  style={{
                    backgroundImage:
                      "url('" +
                      this.getThumbUrl(
                        "/tracks_thumbnails/" + i.rep_track_id + ".jpg"
                      ) +
                      "')",
                    margin: "12px 16px 12px 4px",
                  }}
                />
                <div style={{ flex: "1" }}>
                  <div className="charName">{i.char_name}</div>
                  <div className="charText">{i.occurences} occurences</div>
                </div>
                <IconButton
                  color="primary"
                  className={i.audio_redaction === "AUDIBLE" ? "audible" : ""}
                  onClick={this.toggleMute.bind(this, k)}
                  size="large">
                  <VolumeOffIcon />
                </IconButton>
                <IconButton color="primary" onClick={this.toggleChar.bind(this, k)} size="large">
                  <VisibilityOffIcon />
                </IconButton>
              </div>
            ))}

          {this.state.tab === "logos" &&
            this.props.logos.items.map((i, k) => (
              <div
                className={
                  "flex redactRow" +
                  (this.state.redact_logos.has(i.cluster_id)
                    ? " redactRowActive"
                    : "")
                }
                key={"rl" + i.cluster_id}
              >
                <div
                  className="characterListImg"
                  style={{
                    backgroundImage:
                      "url('" +
                      this.getThumbUrl("/logo_thumbnails/" + i.img_path) +
                      "')",
                    margin: "12px 16px 12px 4px",
                  }}
                />
                <div style={{ flex: "1" }}>
                  <div className="charName">{i.cluster_name}</div>
                  <div className="charText">{i.tracks.length} occurences</div>
                </div>
                <IconButton
                  color="primary"
                  onClick={this.toggleLogo.bind(
                    this,
                    i.cluster_id,
                    this.state.redact_logos.has(i.cluster_id)
                  )}
                  size="large">
                  <VisibilityOffIcon />
                </IconButton>
              </div>
            ))}

          {this.state.tab === "digest" &&
            this.state.text_redaction_states.map((i, k) => (
              <div
                key={"tr" + k}
                className="digestBox flex"
                style={{ alignItems: "flex-start" }}
              >
                <div className="textRedactionBox flex">
                  <VolumeOffIcon
                    title={i.audio_redaction}
                    style={{
                      color: "#1355B2",
                      opacity: "0.59",
                      margin: "0 8px",
                    }}
                  />
                  <div className="textRedactionText">{i.text}</div>
                </div>
                <div className="textRedactionExtra">
                  <div>
                    {this.formatAudio(i.audio_redaction)}{" "}
                    {i.all_occurrences ? "all occurrences: " : "at: "}
                  </div>
                  {i.text_time_segments_list.map((j, l) => (
                    <div
                      className="textRedactionList flex"
                      key={"trs" + l}
                      onClick={this.seekVideo.bind(this, j.start_time)}
                    >
                      {this.formatDuration(j.start_time)}
                      <IconButton
                        color="primary"
                        size="small"
                        onClick={this.removeRedactText.bind(this, k, l)}
                      >
                        <DeleteIcon fontSize="inherit" />
                      </IconButton>
                    </div>
                  ))}
                </div>
                <IconButton
                  hidden
                  color="primary"
                  onClick={this.removeRedactText.bind(this, k, null)}
                  size="large">
                  <DeleteIcon />
                </IconButton>
              </div>
            ))}

          {this.state.tab === "track" && (
            <>
              {this.state.redact_objs.map((i, k) => (
                <div
                  className="objDiv flex"
                  key={"od" + k}
                  onClick={this.seekVideo.bind(this, i.frame_time, true)}
                >
                  <div className="objImg"></div>
                  <div className="objText"><Trans>Custom Object</Trans> {k + 1}</div>
                  <IconButton color="primary" onClick={this.removeRedactObj.bind(this, k)} size="large">
                    <DeleteIcon />
                  </IconButton>
                </div>
              ))}
              <div className="objHelp">
                <HelpOutlineIcon
                  style={{
                    color: "#54667E",
                    opacity: "0.37",
                    fontSize: "40",
                  }}
                />
                <br />
                <Trans>Pause video then drag over object to redact</Trans>
                {false && (
                  <div style={{ whiteSpace: "pre-wrap", textAlign: "left" }}>
                    {JSON.stringify(this.state.redact_objs, null, 2)}
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </WideContainer>
      <Popover
        open={this.state.muteOpen !== false}
        anchorEl={this.state.muteAnchorEl}
        onClose={this.muteClose.bind(this)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{ paper: { className: "redactMutePop" } }}
      >
        <ToggleButtonGroup
          style={{ margin: "6px" }}
          size="small"
          value={this.state.muteValue}
          exclusive
          onChange={this.handleMuteChange}
        >
          <ToggleButton value="AUDIBLE"><Trans>AUDIBLE</Trans></ToggleButton>
          <ToggleButton value="MUTE"><Trans>MUTE</Trans></ToggleButton>
          <ToggleButton value="BEEP"><Trans>BEEP</Trans></ToggleButton>
          <ToggleButton value="MASK"><Trans>MASK</Trans></ToggleButton>
        </ToggleButtonGroup>
      </Popover>
      <Popover
        open={Boolean(this.state.textDialogAnchor)}
        anchorEl={this.state.textDialogAnchor}
        onClose={this.textDialogClose.bind(this)}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        className="textRedactionDialog"
      >
        <div
          style={{
            padding: "8px 12px 12px",
            textAlign: "center",
            position: "relative",
          }}
        >
          <RadioGroup
            row
            aria-label="gender"
            name="gender1"
            value={this.state.redact_text_type}
            onChange={this.handleTextTypeChange}
          >
            <FormControlLabel
              style={{ paddingRight: "16px" }}
              value="MUTE"
              control={<Radio color="primary" />}
              label={<Trans>MUTE</Trans>}
            />
            <FormControlLabel
              value="BEEP"
              control={<Radio color="primary" />}
              label={<Trans>BEEP</Trans>}
            />
          </RadioGroup>
          <div style={{ margin: "0px 0px 8px" }}>
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  checked={this.state.redact_text_all}
                  onChange={this.handleTextAllChange.bind(this)}
                />
              }
              label={<Trans>All instances of the word</Trans>}
              labelPlacement="end"
            />
          </div>
          <div className="flex">
            <Button
              className="Button ButtonXSmall ButtonSecondary"
              size="small"
              onClick={this.textDialogClose.bind(this)}
            >
              <Trans>Cancel</Trans>
            </Button>
            <Button
              className="Button ButtonXSmall ButtonPrimary"
              size="small"
              style={{ flex: "1", zIndex: "1", marginLeft: "12px" }}
              onClick={this.redactText.bind(this)}
            >
              <Trans>Redact</Trans>
            </Button>
          </div>
        </div>
      </Popover>
      <video
        hidden
        ref={this.tvideo}
        crossOrigin="use-credentials"
        src={this.state.playerSource}
        onLoadedData={this.seekThumbnails}
        onSeeked={this.getThumbnail}
      />
      <Dialog
        open={this.state.extractDialog}
        scroll="paper"
        onClose={this.closeExtractDialog.bind(this)}
      >
        <DialogTitle>
          <div
            className="charNameTitle"
            style={{ padding: "16px 8px 0 8px" }}
            id="draggable-dialog-title"
          >
            <Trans>Redact video to clip</Trans>
          </div>
        </DialogTitle>
        <DialogContent>
          <div style={{ width: "490px", display: "flex", padding: "0 8px" }}>
            <div style={{ flex: "1" }}>
              <label
                htmlFor="extractName"
                style={{ color: "#063e6c", fontWeight: "bold" }}
              >
                <Trans>Video Name</Trans>
              </label>
              <br />
              <TextField
                name="extractName"
                id="extractName"
                variant="outlined"
                size="small"
                value={this.state.extractName}
                onChange={this.handleChange}
                type="text"
                fullWidth
              />
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={this.closeExtractDialog.bind(this)}
            color="primary"
          >
            <Trans>Cancel</Trans>
          </Button>
          <Button onClick={this.extractJob.bind(this)} color="primary">
            <Trans>Redact</Trans>
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar open={this.state.extractSuccessDialog}>
        <Alert
          elevation={6}
          variant="filled"
          onClose={this.closeExtractSuccessDialog.bind(this)}
          severity="success"
        >
          <span>
            <Trans>Redaction job started</Trans>.{" "}
            <Link
              to="clips"
              style={{ color: "inherit", textDecoration: "underline" }}
            >
              <Trans>View Clips</Trans>
            </Link>
          </span>
        </Alert>
      </Snackbar>
    </>);
  }
}

const mapState = (state) => {
  return {
    sentences: state.sentences,
    characters: state.characters,
    logos: state.logos,
  };
};
export default withTranslation()(connect(mapState)(Index));
